const items = [
  { k: "RAMS Guaranteed", v: "Site-Specific Risk Assessments & Method Statements" },
  { k: "Trained Operatives", v: "Skilled for Hazardous & Industrial Environments" },
  { k: "Fully Insured", v: "Public & Employer's Liability Cover" },
  { k: "COSHH Logged", v: "Every Chemical with Full Safety Data Sheet" },
];

export default function Compliance() {
  return (
    <section
      data-testid="compliance-section"
      id="compliance"
      className="bg-[#050B14] text-white py-24 md:py-28 border-t border-[#0E2A57] overflow-hidden"
    >
      <div className="container-ags mb-12 md:mb-16">
        <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#BEE7F5] font-medium">
          07 — Compliance & Insurance
        </span>
        <h2 className="mt-6 font-heading font-extrabold text-4xl md:text-6xl leading-[1.02] tracking-[-0.035em] text-white max-w-3xl">
          Institutional-grade compliance <span className="italic-display font-normal text-[#BEE7F5]">with the personal accountability</span> of a family business.
        </h2>
      </div>

      <div className="border-y border-white/15 py-6 overflow-hidden whitespace-nowrap">
        <div className="animate-marquee inline-flex gap-16 text-white/85 font-heading font-light text-3xl md:text-5xl tracking-tight">
          {[...items, ...items].map((it, i) => (
            <span key={i} className="inline-flex items-center gap-16">
              <span className="font-black">{it.k}</span>
              <span className="text-[#BEE7F5]">/</span>
            </span>
          ))}
        </div>
      </div>

      <div className="container-ags mt-16 grid grid-cols-1 md:grid-cols-4 gap-8">
        {items.map((it, i) => (
          <div
            key={it.k}
            data-testid={`compliance-item-${i}`}
            className="border-t border-white/20 pt-6"
          >
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#2BB6E5] mb-3">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className="font-heading font-bold text-xl text-white tracking-[-0.02em]">{it.k}</div>
            <div className="mt-3 text-sm text-white/65 leading-[1.6]">{it.v}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
